import { IGlobalStore } from "../store/global/GlobalStore";
import { Token, WRAPPED_ABI } from "../store/global/TokenEnum";
import { getWrappedSymbolForChain } from "./chainUtils";
import { getContract } from "wagmi/actions";
import { Amount } from "../types/amount";
import { getTokenDecimals } from "../store/global/getAllowances";
import { DUMMY_WALLET, GAS_ESTIMATE_MULTIPLIER } from "../config/consts";
import { TokenMetadata } from "../store/global/getTokenMetadata";
import { parseUnits, PublicClient, WalletClient } from "viem";
import { Chain } from "viem/chains";

export const estimateWrapping = async (
  method: "deposit" | "withdraw",
  contractAddress: string,
  value: Amount,
  walletClient: WalletClient,
  publicClient: PublicClient,
  symbol: Token,
  tokenMetadata: TokenMetadata
): Promise<Amount> => {
  const contract = getContract({
    address: contractAddress as `0x${string}`,
    abi: WRAPPED_ABI,
    walletClient: walletClient,
  });
  try {
    const amount = parseUnits(
      value.value.toString() as `${number}`,
      getTokenDecimals(symbol, tokenMetadata)
    );
    const gas =
      method === "deposit"
        ? await contract.estimateGas.deposit({
            value: amount,
            account: walletClient.account?.address ?? DUMMY_WALLET,
          })
        : await contract.estimateGas.withdraw([amount], {
            account: walletClient.account?.address ?? DUMMY_WALLET,
          });

    const currentGas = await publicClient.getGasPrice();
    const totalGas = currentGas * gas * GAS_ESTIMATE_MULTIPLIER; // Multiplying by 2 to cover gas volatility
    const gasCostInNativeToken = new Amount(totalGas.toString()).div(
      new Amount((10 ** getTokenDecimals(symbol, tokenMetadata)).toString())
    );
    return gasCostInNativeToken;
  } catch (err) {
    console.log(err);
    return Amount.ZERO;
  }
};

export const isWrappingQuantityLargerThanBalance = (store: IGlobalStore) => {
  if (store.wrapQuote?.amount) {
    const wrapQuoteAmount = store.wrapQuote.amount.value;
    const nativeToken = store.network.nativeCurrency.symbol as Token;
    const wrappedToken = getWrappedSymbolForChain(store.network);
    const token = store.wrapQuote.type === "Wrapping" ? nativeToken : wrappedToken;
    const tokenBalance = store.balances.find(balance => balance.symbol === token)?.balance.value;
    return tokenBalance?.lt(wrapQuoteAmount);
  }
  return false;
};

export const isNativeToken = (symbol: Token, network: Chain) => {
  return symbol === network.nativeCurrency.symbol;
};
